<template>
  <div>
    <VehiclesContainer />
  </div>
</template>

<script>
import VehiclesContainer from "@/components/Vehicles/listing/vehiclesContainer.vue";

export default {
  data() {
    return {
      mainTitle: "Main Title",
      subTitle: "Sub Title",
    };
  },
  meta: {
    breadcrumb: "My Page",
  },
  components: {
    VehiclesContainer,
  },
  created() {
    this.$parent.pageTitle = this.mainTitle;
  },
};
</script>
